import http from 'hub-http/clients/apiClient';
const API_BASE = 'hubs-settings/v1/settings';
export default class PortalSettingsAPI {
  static getPortalSetting(key) {
    return http.get(`${API_BASE}?key=${encodeURIComponent(key)}`);
  }
}